export type LayoutVariants = 'page';

export const layout: any = {
  page: {
    backgroundColor: 'bg.400',
    padding: '3em',
    minHeight: '100vh',
  },
};
